module.exports = __webpack_public_path__ + "img/industri_paavirkning_utslipp.2a61b262.jpg";